<uni-snackbar></uni-snackbar>
<ng-container *ngIf="isNewNavFetched">
  <uni-nav-new *ngIf="isNewNav; else oldNav">
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </uni-nav-new>

  <ng-template #oldNav>
    <uni-app-logged>
      <app-nav-wrapper></app-nav-wrapper>
    </uni-app-logged>
  </ng-template>
</ng-container>
